// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/react-tabs/style/react-tabs.css
// module id = 807
// module chunks = 1